"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var axios_1 = __importDefault(require("axios"));

var constants_1 = require("../constants");

exports["default"] = axios_1["default"].create({
  baseURL: constants_1.API_URL
});